
  
function Star() {  
      

  // Create the div display of the stars
    return (  
      <div id="stars-outer">
      <div id="stars-inner"></div>
      </div>
    )  

    }
export default Star